import shared from './changelog.json'
import branchLocal from './changelog.branch.json'

// Combines the shared (master) changelog with the branch-specific one.
//
//  - changelog.json         -> edited on MASTER, shared by every client.
//  - changelog.branch.json  -> edited ONLY on a client branch, stays [] on master.
//
// Kept in two files so `git merge master` never conflicts: master only ever
// touches changelog.json, the branch only ever touches changelog.branch.json.
// Blocks with the same version are merged into one (shared items first, then
// the branch's own items), newest version first.

const cmpVersionDesc = (a, b) => {
  const pa = String(a).split('.').map(n => parseInt(n, 10) || 0)
  const pb = String(b).split('.').map(n => parseInt(n, 10) || 0)
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pb[i] || 0) - (pa[i] || 0)
    if (d) return d
  }
  return 0
}

const mergeChangelog = () => {
  const byVersion = new Map()
  for (const rel of [...shared, ...(branchLocal || [])]) {
    if (!rel || !rel.version) continue
    const cur = byVersion.get(rel.version)
    if (cur) {
      cur.items = [...cur.items, ...(rel.items || [])]
      if (!cur.date && rel.date) cur.date = rel.date
    } else {
      byVersion.set(rel.version, { version: rel.version, date: rel.date, items: [...(rel.items || [])] })
    }
  }
  return [...byVersion.values()].sort((a, b) =>
    cmpVersionDesc(a.version, b.version) || String(b.date || '').localeCompare(String(a.date || '')))
}

const changelog = mergeChangelog()

export default changelog
